import Vue from 'vue';
import Vuetify from 'vuetify';
import VuetifyToast from 'vuetify-toast-snackbar';
import JsonCSV from 'vue-json-csv';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VesselActivityHub from './hubs/VesselActivityHub';
import {
  capitalise,
  uppercase,
  pascalToReadable,
  removeT,
  removeTAndSeconds,
  removeUnderscores,
  removeTAndTime,
  removeTAndSecondsAndFormatDate,
  removeTAndDate,
  removeTAndDateAndSeconds,
  roundNumbers
} from './filters';
import CargoHandlingIcon from './components/ui/CargoHandlingIcon.vue';
import VesselActivityDeckSpaceCalculatorMixin from './mixins/VesselActivityDeckSpaceCalculatorMixin';

// test
Vue.config.productionTip = false;

// Setup vuetify-toast-snackbar
const vuetifyObj = new Vuetify({
  icons: {
    values: {
      'cargo': {
        component: CargoHandlingIcon,
      }
    }
  },
});
Vue.use(VuetifyToast, {
  $vuetify: vuetifyObj.framework, // fix for broken npm package
  x: 'right', // default
  y: 'bottom', // default
  color: 'info', // default
  icon: 'mdi-information',
  iconColor: '', // default
  classes: [
    'body-2',
  ],
  timeout: 4000, // default
  dismissable: true, // default
  multiLine: false, // default
  vertical: false, // default
  queueable: false, // default
  showClose: false, // default
  closeText: '', // default
  closeIcon: 'close', // default
  closeColor: '', // default
  slot: [], // default
  shorts: {
    custom: {
      color: 'purple',
    },
  },
  property: '$toast', // default
});

// SignalR Hub.
Vue.use(VesselActivityHub);

// Vue-Json-CSV
Vue.component('downloadCsv', JsonCSV);

// Register global filters
Vue.filter('capitalise', capitalise);
Vue.filter('uppercase', uppercase);
Vue.filter('pascalToReadable', pascalToReadable);
Vue.filter('removeT', removeT);
Vue.filter('removeTAndSeconds', removeTAndSeconds);
Vue.filter('removeTAndDateAndSeconds', removeTAndDateAndSeconds);
Vue.filter('removeTAndTime', removeTAndTime);
Vue.filter('removeTAndDate', removeTAndDate);
Vue.filter('removeUnderscores', removeUnderscores);
Vue.filter('removeTAndSecondsAndFormatDate', removeTAndSecondsAndFormatDate);
Vue.filter('roundNumbers', roundNumbers);

const app = new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
});

app.$mount('#app');
